import { IABase } from './InteractiveArea'
import { Shot } from './Shot'
import { VideoEntityEvent } from './VideoEntityEvent'

export class InteractiveAreaAPI extends IABase {
  shots: Shot[]
  events: VideoEntityEvent[]

  constructor (area: InteractiveAreaAPI) {
    super()
    for (const property in area) {
      this[property] = area[property]
    }
  }
}
